var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentCancelled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F4F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16858_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6V8.66667C13.3333 8.84348 13.4035 9.01305 13.5285 9.13807C13.6535 9.2631 13.8231 9.33333 13.9999 9.33333H16.6666",
    stroke: "#596975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 18H8.66659C8.31296 18 7.97382 17.8595 7.72378 17.6095C7.47373 17.3594 7.33325 17.0203 7.33325 16.6667V7.33333C7.33325 6.97971 7.47373 6.64057 7.72378 6.39052C7.97382 6.14048 8.31296 6 8.66659 6H13.3333L16.6666 9.33333V10.6667",
    stroke: "#596975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16858_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 16C13 16.394 13.0776 16.7841 13.2284 17.1481C13.3791 17.512 13.6001 17.8427 13.8787 18.1213C14.1573 18.3999 14.488 18.6209 14.8519 18.7716C15.2159 18.9224 15.606 19 16 19C16.394 19 16.7841 18.9224 17.1481 18.7716C17.512 18.6209 17.8427 18.3999 18.1213 18.1213C18.3999 17.8427 18.6209 17.512 18.7716 17.1481C18.9224 16.7841 19 16.394 19 16C19 15.606 18.9224 15.2159 18.7716 14.8519C18.6209 14.488 18.3999 14.1573 18.1213 13.8787C17.8427 13.6001 17.512 13.3791 17.1481 13.2284C16.7841 13.0776 16.394 13 16 13C15.606 13 15.2159 13.0776 14.8519 13.2284C14.488 13.3791 14.1573 13.6001 13.8787 13.8787C13.6001 14.1573 13.3791 14.488 13.2284 14.8519C13.0776 15.2159 13 15.606 13 16Z",
    stroke: "#596975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14L18 18",
    stroke: "#596975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16858_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16858_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCancelled);
export default __webpack_public_path__ + "static/media/payment_cancelled.52dffffa0d4749acaf5d75da613b2225.svg";
export { ForwardRef as ReactComponent };